
import { Fragment, useState } from "react";
import {
  Button,
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
  Spinner,
  Typography,
} from "@material-tailwind/react";
import { useForm } from 'react-hook-form';
import AInput from "../fields/AInput";
import { useShared } from '../../hooks/useShared';
import AIcon from "../partials/AIcon";

export default function SendResetPasswordLinkDialog({ v }) {
  const {
    register,
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm();
  const [loading, setLoading] = useState(false)
  const [errMsg, setErrMsg] = useState(null)
  const [successMsg, setSuccessMsg] = useState(null)
  const { http } = useShared();

  const sendResetPasswordLinkHandle = (data) => {
    setLoading(true)
    console.log("sendResetPasswordLinkHandle ", data);
    http.post(`api/send-password-reset-email`, data).then(res => {
      console.log(res);
      if (res?.data?.success) {
        setLoading(false)
        setValue("email", null)
        setSuccessMsg(res?.data?.message)
      }
    }, error => {


      setLoading(false)
      console.log(error);

      const err = error?.response?.data

      if (!err?.success) {
        setErrMsg(err?.message)
      }

    })
  }
  const closeDialog = () => {
    v?.setSendResetPasswordLinkDialog(false)
    setValue("email", null)
    setErrMsg(null)
    setSuccessMsg(null)
  }


  return (
    <Fragment>

      <Dialog open={v?.sendResetPasswordLinkDialog} className="min-w-[90%] md:min-w-[40%] border-main-color absolute top-0  "
        animate={{
          mount: { scale: 1, y: 0 },
          unmount: { scale: 0.9, y: -100 },
        }}
      >
     
        <DialogHeader className="bg-main-color py-1 px-2 text-blue-gray-100  text-base flex justify-between">Send Password Rest Link
          <Button className="p-0 m-0 bg-transparent border-transparent" onClick={closeDialog}>  <AIcon name="close-outline" size={20} className="p-1" /> </Button>
        </DialogHeader>

        <form autoComplete="off" className="mt-5 flex flex-col gap-4" onSubmit={handleSubmit(sendResetPasswordLinkHandle)}>
          <DialogBody >
            {successMsg == null && <div className=" grid  gap-6 items-baseline">
              <AInput v={{ register, errors, control, data: { label: 'Email', name: 'email', type: 'email', isStyle: true, required: "Email address is required.", icon: 'at-sharp' } }} />

            </div>
            }

            {errMsg && <Typography
              variant="small"
              color="gray"
              className="flex items-center text-red-500 gap-2 font-normal mt-5"
            >
              <AIcon name="alert-circle-outline" className="-mt-0.5 h-4 w-4" />
              {errMsg}
            </Typography>}

            {successMsg && <Typography
              variant="small"
              color="gray"
              dir="rtl"
              className="flex items-center text-green-700 gap-2 font-normal mt-5 text-base amiriB"
            >
              <AIcon name="checkmark-done-sharp" className="-mt-0.5 h-4 w-4" />
              {successMsg}
            </Typography>}


          </DialogBody>
          <DialogFooter className=" p-2">
            <Button
              variant="text"
              color="red"
              onClick={closeDialog}
              className="mr-1"
            >
              <span>Close</span>
            </Button>
            {successMsg == null && <Button className="bg-main-color" type="submit" size="sm">
              {loading ? <Spinner color="teal" className="h-4 w-4" /> : "ارسال"}
            </Button>}
          </DialogFooter>
        </form>
      </Dialog>
    </Fragment>
  )
}
